// Package imports:
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Component imports:
import Container from 'react-bootstrap/Container';
import ReportOfCancelledTrades from './ReportOfCancelledTrades';
import ReportOfBrokenTradeReports from './ReportOfBrokenTradeReports';
import ReportOfAlertSummary from './summaryPerClientOrTrader/ReportOfAlertSummary';
import ReportOfAlertSummaryPerTraderId from './summaryPerClientOrTrader/ReportOfAlertSummaryPerTraderId';
import ReportOfAlertSummaryPerClientId from './summaryPerClientOrTrader/ReportOfAlertSummaryPerClientID';
// Service imports:
// Action imports:
// Type imports:
interface IOwnProps {
    reportId: number
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

const reportNames: { [key: number]: string } = {
    1: 'Cancelled Trades',
    2: 'Broken Trade Reports',
    3: 'Alert Summary',
    4: 'Alert Summary Per Trader',
    5: 'Alert Summary Per Client',
};

const SingleReport: React.FC<Props> = ({
    reportId
}) => {
    useEffect(() => {
        const reportName = reportNames[reportId] || 'Report';
        document.title = `${reportName} | KODIAK Sigti`;
    }, [ reportId ]);

    return (
        <Container id='SingleReport' fluid>
            {
                (reportId === 1) // if
                ? <ReportOfCancelledTrades />
                : (reportId === 2) // else if
                ? <ReportOfBrokenTradeReports />
                : (reportId === 3) // else if
                ? <ReportOfAlertSummary />
                : (reportId === 4) // else if
                ? <ReportOfAlertSummaryPerTraderId />
                : (reportId === 5) // else if
                ? <ReportOfAlertSummaryPerClientId />
                : null
            }
        </Container>
    );
}

function mapStateToProps() {
    return {};
}

const connector = connect(mapStateToProps);
export default connector(SingleReport);
